<script setup>
import page from '@/preload/data/accessibilityPage.json'
import config from '@/preload/data/config.json'

useHead({
  title: `${config.pagetitle} | ${page.title || 'Erklärung zur Barrierefreiheit'}`
})
</script>

<template>
  <div v-if="page" :class="page.withoutVerticalSpace ? '' : 'mt-10'">
    <cms-block-renderer :blocks="page.blocks" />
  </div>
</template>
